/*
 * Public API Surface of saraplus-ngx-common
 */

export * from './lib/sp-overlay/sp-overlay.module';
export * from './lib/sp-overlay/sp-overlay.component';
